import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AdminContext } from './AdminContext';

const navStyle = {
  display: 'flex',
  gap: 16,
  marginBottom: 24,
  background: '#f5f5f5',
  padding: '12px 24px',
  borderRadius: 8,
  alignItems: 'center',
};
const linkStyle = isActive => ({
  color: isActive ? '#006400' : '#222',
  textDecoration: 'none',
  fontWeight: isActive ? 700 : 500,
  padding: '4px 8px',
  borderBottom: isActive ? '2px solid #006400' : 'none',
});

export default function AdminNav() {
  const { user, logout } = useContext(AdminContext);
  const location = useLocation();
  if (!user) return null;
  return (
    <nav style={navStyle}>
      <Link to="/admin/dashboard" style={linkStyle(location.pathname === '/admin/dashboard')}>Dashboard</Link>
      <Link to="/admin/users" style={linkStyle(location.pathname === '/admin/users')}>Users</Link>
      <Link to="/admin/registrations" style={linkStyle(location.pathname === '/admin/registrations')}>Hackathon</Link>
      <Link to="/admin/volunteers" style={linkStyle(location.pathname === '/admin/volunteers')}>Volunteers</Link>
      <Link to="/admin/ceremony" style={linkStyle(location.pathname === '/admin/ceremony')}>Ceremony</Link>
      <Link to="/admin/export" style={linkStyle(location.pathname === '/admin/export')}>Export</Link>
      <Link to="/admin/change-password" style={linkStyle(location.pathname === '/admin/change-password')}>Change Password</Link>
      <span style={{ flex: 1 }} />
      <span style={{ color: '#888', fontSize: 14 }}>{user.email} ({user.role})</span>
      <button onClick={logout} style={{ marginLeft: 16, padding: '4px 12px', background: '#eee', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Logout</button>
    </nav>
  );
}
